import { render } from "./Arera.vue?vue&type=template&id=508e5577"
import script from "./Arera.vue?vue&type=script&lang=js"
export * from "./Arera.vue?vue&type=script&lang=js"

import "./Arera.vue?vue&type=style&index=0&id=508e5577&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__